import { useTranslation } from 'react-i18next';

import {
  Modal,
  Button,
  ButtonsWrapper,
  Form,
  PLATFORM_THEME_COLORS,
  DatePickerInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

const EmployeeWorkingHoursChangeModal = ({
  onClose,
  onSubmit,
}: {
  onClose: () => void;
  onSubmit: (date: Date) => void;
}) => {
  const { t, i18n } = useTranslation(['settings', 'common']);

  return (
    <Modal
      isOpened
      onClose={onClose}
      title={t('settings:company.changingEmployeeWorkingHours.title')}
    >
      <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey} style={{ marginBottom: '16px' }}>
        {t('settings:company.changingEmployeeWorkingHours.subTitle')}
      </Typography>

      <Form layout="vertical" onFinish={({ startFrom }) => onSubmit(startFrom.toDate())}>
        <Form.Item
          name="startFrom"
          label={t('settings:company.changingEmployeeWorkingHours.label')}
          rules={[{ required: true, message: t('common:validation.error.fieldRequired') }]}
        >
          <DatePickerInput lang={i18n.language} format="DD.MM.YYYY" />
        </Form.Item>
        <ButtonsWrapper marginTop={16}>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.confirm')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </Modal>
  );
};

export default EmployeeWorkingHoursChangeModal;
